module.exports = __webpack_public_path__ + "img/send.db131b30.svg";